import { Link } from "react-router-dom";
import { Mail, MapPin, Linkedin } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import Logo from "./Logo";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer data-testid="site-footer" className="bg-navy-950 text-slate-300">
      <div className="gold-hairline" />
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:grid-cols-2 sm:px-6 lg:grid-cols-4 lg:px-12">
        <div>
          <Logo dark />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">{t("footer.tagline")}</p>
          <div className="mt-5 flex items-center gap-3">
            <a
              data-testid="footer-email-link"
              href="mailto:info@stratedgeuk.com"
              className="inline-flex items-center gap-2 text-sm text-gold-light transition-colors hover:text-gold"
            >
              <Mail className="h-4 w-4" /> info@stratedgeuk.com
            </a>
          </div>
          <p className="mt-2 inline-flex items-center gap-2 text-sm text-slate-400">
            <MapPin className="h-4 w-4 text-gold" /> {t("contact.hq")}
          </p>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-gold">{t("footer.explore")}</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link data-testid="footer-link-services" className="transition-colors hover:text-gold-light" to="/services">{t("nav.services")}</Link></li>
            <li><Link data-testid="footer-link-training" className="transition-colors hover:text-gold-light" to="/training">{t("nav.training")}</Link></li>
            <li><Link data-testid="footer-link-experts" className="transition-colors hover:text-gold-light" to="/experts">{t("nav.experts")}</Link></li>
            <li><Link data-testid="footer-link-insights" className="transition-colors hover:text-gold-light" to="/insights">{t("nav.insights")}</Link></li>
            <li><Link data-testid="footer-link-videos" className="transition-colors hover:text-gold-light" to="/videos">{t("nav.videos")}</Link></li>
            <li><Link data-testid="footer-link-research" className="transition-colors hover:text-gold-light" to="/research-consultants">{t("research.tabResearch")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-gold">{t("footer.company")}</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link data-testid="footer-link-about" className="transition-colors hover:text-gold-light" to="/about">{t("nav.about")}</Link></li>
            <li><Link data-testid="footer-link-join" className="transition-colors hover:text-gold-light" to="/join">{t("nav.join")}</Link></li>
            <li><Link data-testid="footer-link-consultation" className="transition-colors hover:text-gold-light" to="/consultation">{t("nav.book")}</Link></li>
            <li><Link data-testid="footer-link-contact" className="transition-colors hover:text-gold-light" to="/contact">{t("nav.contact")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-gold">{t("footer.legal")}</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link data-testid="footer-link-privacy" className="transition-colors hover:text-gold-light" to="/privacy">{t("footer.privacy")}</Link></li>
            <li><Link data-testid="footer-link-terms" className="transition-colors hover:text-gold-light" to="/terms">{t("footer.terms")}</Link></li>
            <li><Link data-testid="footer-link-expert-portal" className="transition-colors hover:text-gold-light" to="/expert-portal">Expert Portal</Link></li>
            <li><Link data-testid="footer-link-client-portal" className="transition-colors hover:text-gold-light" to="/client-portal">{t("portal.client")}</Link></li>
            <li><Link data-testid="footer-link-admin" className="transition-colors hover:text-gold-light" to="/admin">{t("nav.login")}</Link></li>
          </ul>
          <a
            data-testid="footer-linkedin"
            href="https://www.linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-2 text-sm text-slate-400 transition-colors hover:text-gold-light"
          >
            <Linkedin className="h-4 w-4" /> LinkedIn
          </a>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Stratedge UK. {t("footer.rights")}
      </div>
    </footer>
  );
}
